export default __webpack_public_path__ + "static/media/ic_wmatic_24.8fbda589.svg";